import db from 'mime-db'

export default abstract class MimeTypes {
  public static getFileExtension(mimeType: string): string | undefined {
    return db[mimeType]?.extensions?.[0]
  }
}
